export default function(_el) {

  // DOM.
  const ul = _el.querySelector('.carousel__ul');
  const items = ul?.children;
  const nav = _el.querySelector('.carousel__nav');
  const navBtns = nav?.querySelectorAll('button');

  // Props.
  let curr = 1;
  let snapPoints = [];
  let maxScrollLeft;

  const calculateMaxScrollLeft = () => {
    maxScrollLeft = ul.scrollWidth - ul.clientWidth;
  }

  const calculateSnapPoints = () => {
    snapPoints = [];
    const leftOffset = items[0].getBoundingClientRect().left;
    [...items].forEach(item => {
      const rect = item.getBoundingClientRect();
      const x = Math.round(rect.left - leftOffset);
      if (x - rect.width <= maxScrollLeft) {
        snapPoints.push(x);
      }
    });
  }

  const initNav = () => {
    navBtns[0].disabled = (curr == 1) ? true : false;
    navBtns[1].disabled = (curr >= snapPoints.length) ? true : false;
  }

  const goNext = () => {
    const nextIndex = curr + 1;
    slideToItem(nextIndex);
  }

  const goPrev = () => {
    const prevIndex = curr - 1;
    slideToItem(prevIndex);
  }

  const slideToItem = index => {
    ul.scroll({
      left: snapPoints[index - 1],
      top: 0,
      behavior: 'smooth'
    })
    curr = index;

    initNav();
  }

  // Resize observer.
  const ulRO = new ResizeObserver((entries) => {
    calculateMaxScrollLeft();
    calculateSnapPoints();
    slideToItem(1);
  });
  ulRO.observe(ul);

  
  if (nav) {
    nav.addEventListener('click', e => {
      const button = e.target.closest('button');
      if (button) {
        if (button.classList.contains('carousel__nav-left')) {
          goPrev();
        } else {
          goNext();
        }
      }
    });
  }

  if (items) {
    [...items].forEach(item => {
      item.querySelector('a').addEventListener('focus', e => {
        const li = e.target.closest('li');
        const n = [...li.parentNode.children].indexOf(li) + 1;
        slideToItem(n);
      })
    })
  }
}